import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { useSportsSettings } from '@namespace/cms';
import { LINE_VIEW } from '../../constants';
import { useEventFields } from '../../store';

import styles from './index.module.css';

const EventLinePosition = ({ eventId, lineView }) => {
  const { eventLinePosition } = useEventFields({
    eventId,
    fields: ['eventLinePosition']
  });
  const { isShowEventLinePosition = false } = useSportsSettings();
  const isButtonView = lineView === LINE_VIEW.BUTTON;

  return (
    isShowEventLinePosition && (
      <Box
        className={clsx([
          styles.eventLinePositionWrapper,
          isButtonView && styles.eventLinePositionButton
        ])}
        align="center"
      >
        <AText breed="B" color="txt_color_5" size="xs">
          {`#${eventLinePosition}`}
        </AText>
      </Box>
    )
  );
};

export default EventLinePosition;
